import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { surveyReducer } from './surveys.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SurveyEffects } from './survey.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('survey', surveyReducer),
    EffectsModule.forFeature([SurveyEffects])
  ]
})
export class SurveysModule { }
